/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.

#  To run  source env/bin/activate  or env\Scripts\activate for windows
#  python3 main.py
# npm run build --max-old-space-size=8192
# gcloud app deploy  gcloud app deploy
*/

export const dataurl = "https://backend-dot-paksh-app.el.r.appspot.com"
//export const dataurl = "http://localhost:8080"

export const caseTypeCategory = {'API':'Application','APE':'Appeal','FAP':'First Appeal','SAP':'Second Appeal',
'REF':'Reference','RVN':'Revision','COP':'Case/Petition','SUT':'Suit','WRP':'Writ Petition','ORG':'Original',
'EXE':'Execution','RVW':'Review'}

export const matterType= {'CV' : 'Civil', 'CR' : 'Criminal'}

export const pAreas= {'ADM':'Admiralty','ARB':'Arbitration','BKP':'Bankruptcy and Debt','BAN': 'Banking',
'BIZ':'Companies Law','CHR':'Civil Rights',
'CON':'Contractual','CRM':'Criminal Law','EDU':'Education Law','ELE':'Election',
'ENV':'Environment Law','WIT':'Expert Witness',
'FAM':'Family - Matrimonial','FRN':'Foreign Law','GOV':'Government','IMG':'Immigration',
'INS':'Insurance','IPL':'Intellectual Property',
'INT':'International Law','LAE':'Labor and Employment','SUT':'Lawsuits',
'PIN':'Personal Injury','REA':'Real Estate / Land',
'PIL': 'Public Interest Litigation',
'TRU':'Trusts and Estates','DOC':'Documentation','NOT':'Legal Notice',
'TAX':'Tax/Excise/Duty/Cess','SEC':'Securities Law'}